import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    connect(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    status(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    getlistDataProduct(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    syncProducts(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    getlistDataPartner(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    syncPartners(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    getListPartnerSyncKiotvietConnected(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    getlistDataDelivery(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    syncDeliveries(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    getlistDataDeliveryDetail(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
})()